// Initial content, pillar colors, and priority order from GB Roadmap 2026.pptx.
// Edits are stored per roadmap in settings.executiveBoard, alongside existing settings.

export const EXECUTIVE_ITEMS = [
  {"id": "IF01", "name": "Microblink Offer Wall / Receipt Snap", "status": "Completed", "pillar": "advertising", "rank": 0},
  {"id": "IF03", "name": "Flash Deals Station Detail — CTA", "status": "Completed", "pillar": "advertising", "rank": 1},
  {"id": "AD11", "name": "Retail Deal Alerts Productization", "status": "Shipping Soon", "pillar": "advertising", "rank": 2},
  {"id": "AD13", "name": "IAB — Partner SDK", "status": "Shipping Soon", "pillar": "advertising", "rank": 3},
  {"id": "IF08", "name": "Ad Server Decision: SM2 vs. Full GAM", "status": "Research", "pillar": "advertising", "rank": 4},
  {"id": "AD06", "name": "GRID-E Phase 3 · MyCar Ad Unit + Way Car Wash", "status": "Planned", "pillar": "advertising", "rank": 5},
  {"id": "AD07", "name": "MyCar (Non-Grid-E)", "status": "Planned", "pillar": "advertising", "rank": 6},
  {"id": "AD14", "name": "Retail Deal Alerts (Non-Pay)", "status": "New Planned", "pillar": "advertising", "rank": 7},
  {"id": "AD09", "name": "Age Verification → Webview", "status": "Deprioritized", "pillar": "advertising", "rank": 8},
  {"id": "AD08a", "name": "Improved Website Ad Yield", "status": "Research", "pillar": "advertising", "rank": 9},
  {"id": "AD15", "name": "Growth Energy — E15 Filter + Pricing Feed", "status": "Planned", "pillar": "advertising", "rank": 10},
  {"id": "SU14", "name": "Apple / Google Pay for Enrollment", "status": "Deprioritized", "pillar": "subscription", "rank": 11},
  {"id": "SU15", "name": "Mid-Tier Ad-Reduced Sub — 110K × $2/mo", "status": "Deprioritized", "pillar": "subscription", "rank": 12},
  {"id": "SU16", "name": "Ad-Reduced Tier (App Refresh Bundle)", "status": "Deprioritized", "pillar": "subscription", "rank": 13},
  {"id": "SU17", "name": "Membership Stacking: Premium vs. Plus", "status": "Deprioritized", "pillar": "subscription", "rank": 14},
  {"id": "IF06", "name": "Onboarding & Registration Revamp (P1)", "status": "Shipping Soon", "pillar": "ux", "rank": 15},
  {"id": "UX03", "name": "GRID-E 1 · Home Screen Redesign — Sections, Hero", "status": "In Development", "pillar": "ux", "rank": 16},
  {"id": "UX04", "name": "GRID-E Phase 2 · Contextual Cards: Geo-Targeted (CMS)", "status": "In Development", "pillar": "ux", "rank": 17},
  {"id": "UX29", "name": "Price Reporting – Challenges & Achievements – Monetization", "status": "Research", "pillar": "ux", "rank": 18},
  {"id": "UX05", "name": "ada Chat In-App (fuely) · Now Cognigy", "status": "Planned", "pillar": "ux", "rank": 19},
  {"id": "UX02", "name": "GRID-E Phase 2 · Style Guide + Component Library", "status": "Planned", "pillar": "ux", "rank": 20},
  {"id": "UX18", "name": "Find Gas Refresh — Favorites, Route Nav", "status": "Deprioritized", "pillar": "ux", "rank": 21},
  {"id": "UX22", "name": "CarPlay & Android Auto + Monetize Pins", "status": "Deprioritized", "pillar": "ux", "rank": 22},
  {"id": "LH26", "name": "Build vs. Buy: PDI Loyalty vs. Salesforce Loyalty — BUILD", "status": "Completed", "pillar": "marketing", "rank": 23},
  {"id": "CF01", "name": "Corpay Fleet Customer Acquisition", "status": "In Development", "pillar": "marketing", "rank": 24},
  {"id": "AD12", "name": "FR Connect Auth Migration", "status": "In Progress", "pillar": "marketing", "rank": 25},
  {"id": "LH27", "name": "Salesforce Loyalty Replacement (~$400K/yr)", "status": "Planned", "pillar": "marketing", "rank": 26},
  {"id": "LH28", "name": "Braze vs. Salesforce Marketing Cloud", "status": "Research", "pillar": "marketing", "rank": 27},
  {"id": "LH30", "name": "Ongoing Marketing Promotion Support", "status": "Planned", "pillar": "marketing", "rank": 28},
  {"id": "FP21", "name": "Corpay Data Normalization → Customer 360", "status": "Deprioritized", "pillar": "infrastructure", "rank": 29, "deprioritizedInDone": true},
  {"id": "IF09", "name": "OFAC In House + Drop Corpay", "status": "In Development", "pillar": "infrastructure", "rank": 30},
  {"id": "IF02", "name": "PwGB+ Bank Compliance (BSA/AML, Reg E/Z/B)", "status": "Always On", "pillar": "infrastructure", "rank": 31},
  {"id": "IF07", "name": "Validify → Mastercard Open Finance (IAV)", "status": "In Progress", "pillar": "infrastructure", "rank": 32},
  {"id": "AD08", "name": "Anti-Scraping", "status": "Research", "pillar": "infrastructure", "rank": 33},
  {"id": "FP23", "name": "Direct Price Feeds (P97, Business Pages)", "status": "Research", "pillar": "infrastructure", "rank": 34},
  {"id": "FP24", "name": "Shell Real-Time Pricing (FR authoritative)", "status": "Planned", "pillar": "infrastructure", "rank": 35},
  {"id": "IF05", "name": "Automated Station Trust Scoring", "status": "Deprioritized", "pillar": "infrastructure", "rank": 36},
  {"id": "IF10", "name": "Measurement around Retail Deal Alerts", "status": "Planned", "pillar": "infrastructure", "rank": 37},
  {"id": "LH29", "name": "Corpay Digital Wallet", "status": "Planned", "pillar": "infrastructure", "rank": 38},
];

export const EXECUTIVE_PILLARS = [
  { id: "advertising", name: "Advertising & Partners", color: "#006EA6" },
  { id: "subscription", name: "Subscription", color: "#5C3D99" },
  { id: "ux", name: "App UX Refresh", color: "#008280" },
  { id: "marketing", name: "Marketing / Loyalty Host", color: "#B56D00" },
  { id: "infrastructure", name: "Compliance / Infrastructure", color: "#1A3A6B" },
];

export const EXECUTIVE_STATUSES = {
  Planned: { color: "#4F5E5E", background: "#F5F6F8" },
  "New Planned": { color: "#4F5E5E", background: "#F5F6F8" },
  "In Progress": { color: "#FFFFFF", background: "#008B5A" },
  "In Development": { color: "#FFFFFF", background: "#AF0081" },
  Research: { color: "#07003F", background: "#FFB200" },
  "Shipping Soon": { color: "#FFFFFF", background: "#0A25B1" },
  "Always On": { color: "#07003F", background: "#00A3B8" },
  Completed: { color: "#FFFFFF", background: "#005A32" },
  Deprioritized: { color: "#FFFFFF", background: "#4F5E5E" },
};

export const EXECUTIVE_SIZES = [
  { id: "XL", label: "XL", description: "2 teams, 6–8 sprints" },
  { id: "L", label: "L", description: "2 teams, 4–5 sprints" },
  { id: "M", label: "M", description: "2 teams, 2–3 sprints" },
  { id: "S", label: "S", description: "1 team, 2 sprints" },
  { id: "XS", label: "XS", description: "1 team, 1 sprint" },
];

// Executive reporting has its own status and pillar. Moving a card must not
// silently reschedule engineering work or move it between timeline buckets.
export function getExecutiveItems(board = {}) {
  return EXECUTIVE_ITEMS.map(seed => {
    const saved = board?.items?.[seed.id] || {};
    return {
      ...seed,
      status: Object.hasOwn(EXECUTIVE_STATUSES, saved.status) ? saved.status : seed.status,
      size: EXECUTIVE_SIZES.some(size => size.id === saved.size) ? saved.size : "",
      pillar: EXECUTIVE_PILLARS.some(p => p.id === saved.pillar) ? saved.pillar : seed.pillar,
      rank: Number.isFinite(saved.rank) ? saved.rank : seed.rank,
    };
  }).sort((a, b) => a.rank - b.rank || a.id.localeCompare(b.id));
}

export function isExecutiveItemVisible(item, view) {
  const archived = item.deprioritizedInDone && item.status === "Deprioritized";
  return view === "done"
    ? item.status === "Completed" || item.status === "Shipping Soon" || archived
    : item.status !== "Completed" && !archived;
}

// Actions are applied to the latest shared settings, never a captured snapshot.
// Only board metadata is changed, preserving all other roadmap settings.
export function updateExecutiveSettings(settings, action) {
  const board = settings?.executiveBoard || {};
  const items = getExecutiveItems(board);
  const item = items.find(i => i.id === action.id);
  if (!item) return settings;
  const overrides = { ...board.items };
  if (action.type === "status" && Object.hasOwn(EXECUTIVE_STATUSES, action.status)) {
    overrides[item.id] = { ...overrides[item.id], status: action.status };
  } else if (action.type === "size" && (action.size === "" || EXECUTIVE_SIZES.some(size => size.id === action.size))) {
    overrides[item.id] = { ...overrides[item.id], size: action.size };
  } else if (action.type === "move" && EXECUTIVE_PILLARS.some(p => p.id === action.pillar)) {
    if (action.beforeId === item.id || action.afterId === item.id) return settings;
    const destination = items.filter(i => i.pillar === action.pillar && i.id !== item.id);
    let index = destination.length;
    if (action.beforeId) {
      index = destination.findIndex(i => i.id === action.beforeId);
      if (index < 0) return settings;
    } else if (action.afterId) {
      index = destination.findIndex(i => i.id === action.afterId);
      if (index < 0) return settings;
      index += 1;
    }
    destination.splice(index, 0, { ...item, pillar: action.pillar });
    destination.forEach((i, rank) => {
      overrides[i.id] = { ...overrides[i.id], pillar: action.pillar, rank };
    });
  } else return settings;
  return { ...settings, executiveBoard: { ...board, items: overrides } };
}
